import { createRequiredValidators } from "@xo/client-common";
import { Type8Timestamp } from "./Type8Timestamp";

export function createType8TimestampValidators() {
    return [
        ...createRequiredValidators<Type8Timestamp>(["simpleField", "valueListField", "validatedField", "arrayField", "valueListArray", "validatedArrayField"]),
    ];
}
